function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.41984 2.66665C11.3598 2.66665 13.7532 5.05998 13.7532 7.99998C13.7532 10.94 11.3598 13.3333 8.41984 13.3333C5.47984 13.3333 3.08651 10.94 3.08651 7.99998C3.08651 5.05998 5.47984 2.66665 8.41984 2.66665ZM8.41984 1.33331C4.73984 1.33331 1.75317 4.31998 1.75317 7.99998C1.75317 11.68 4.73984 14.6666 8.41984 14.6666C12.0998 14.6666 15.0865 11.68 15.0865 7.99998C15.0865 4.31998 12.0998 1.33331 8.41984 1.33331ZM7.75317 5.33331H6.41984V10.6666H7.75317V5.33331ZM11.7532 7.99998L8.41984 5.33331V10.6666L11.7532 7.99998Z"
});

var SvgIcNotStarted = function SvgIcNotStarted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "white",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcNotStarted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_not_started.553bcacd.svg";
export { ForwardRef as ReactComponent };